var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateECmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.8,10.4c-8.2,1.2-15.1,8.3-16.3,16.7C10.2,28.8,10,63.9,10,109c0,84.3,0,82.4,2.2,86.8 c2.4,4.7,6.7,8.4,11.5,9.9c2.9,0.9,4.2,0.9,35.1,0.9h32.1l-0.3-1.1c-1.6-5.5-2.4-18-1.7-25.4c1.7-17.8,7.2-32.1,17.6-46.2 c13.5-18.2,34.5-30.8,57.4-34.4l3.6-0.6v-9.3c0-10.3-0.5-13.3-2.7-16.9c-0.7-1.2-11.7-14.6-24.5-29.9 c-24.4-29.3-24.7-29.6-30.3-31.7c-2.2-0.8-4.3-0.9-41.5-0.9C46.8,10.1,28.1,10.2,26.8,10.4z M59.4,64.2v15h-9.9h-9.9v-15v-15h9.9 h9.9V64.2z M88.9,64.2v15H79h-9.9v-15v-15H79h9.9V64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.2,119.3c-2.4,1.1-73.3,72.1-74.1,74.1c-1,2.6-10.6,41.8-10.6,43.1c0,3.2,2,6.5,4.8,8.2 c3.6,2,3.6,2,26.6-3.7c11.8-3,22-5.7,22.8-6.2c2.3-1.4,71.6-71.2,72.5-72.9c1.1-2.1,1.1-6.2,0-8.3c-0.5-0.9-7.8-8.6-16.4-17.3 c-16.4-16.5-18-17.8-22-17.8C205.8,118.4,204.2,118.8,203.2,119.3z M215.2,149.8l7.8,7.8l-8,8l-7.9,7.9l-7.9-7.9l-8-8l7.8-7.8 c4.3-4.3,7.9-7.8,8.1-7.8C207.2,142,210.9,145.5,215.2,149.8z M185.6,179.4l7.8,7.9l-15.6,15.3l-15.5,15.3l-10.4,2.6 c-5.7,1.4-10.4,2.5-10.4,2.4s1.2-4.8,2.5-10.4l2.6-10.2l15.3-15.4c8.4-8.4,15.4-15.3,15.6-15.3 C177.7,171.5,181.3,175,185.6,179.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateECmr);
export default __webpack_public_path__ + "static/media/create-e-cmr.f0bba718db10241d6ffcb0e7515704d5.svg";
export { ForwardRef as ReactComponent };